symbolAnimator = {};
symbolAnimator.animationPool = [
  {
    poolName: "Empty",
    number: 0,
    pool: [],
    anims: [],
    backings: [],
  },
];
symbolAnimator.currentAnimations = [];
symbolAnimator.gameReels = undefined;
symbolAnimator.slotContainer = undefined;
symbolAnimator.ready = false;
symbolAnimator.finishedCallback = undefined;
symbolAnimator.completeCallback = undefined;

symbolAnimator.symbolIDMap = [
  { id: 0, name: "Ten", anim: 0, scale: 1 },
  { id: 1, name: "Jack", anim: 0, scale: 1 },
  { id: 2, name: "Queen", anim: 0, scale: 1 },
  { id: 3, name: "King", anim: 0, scale: 1 },
  { id: 4, name: "Ace", anim: 0, scale: 1 },
  { id: 5, name: "Lure", anim: 0, scale: 1 },
  { id: 6, name: "Float", anim: 0, scale: 1 },
  { id: 7, name: "Rod", anim: 0, scale: 1 },
  { id: 8, name: "Tackle", anim: 0, scale: 1 },
  { id: 9, name: "Trawler", anim: 0, scale: 1 },
  { id: 10, name: "Logo", anim: 0, scale: 1 },
  { id: 11, name: "Wild", anim: 0, scale: 1 },
  { id: 12, name: "Empty", anim: 0, scale: 1 }, //Bonus
  { id: 13, name: "Empty", anim: 0, scale: 1 }, //Mystery
  { id: 14, name: "Fisherman", anim: 0, scale: 1 },
  { id: 15, name: "Respin", anim: 0, scale: 1 },
  { id: 16, name: "Respin", anim: 1, scale: 1 },
  { id: 17, name: "Respin", anim: 2, scale: 1 },
  { id: 18, name: "Coin", anim: 0, scale: 1 },
  { id: 19, name: "Empty", anim: 0, scale: 1 }, //LegendaryCatch
  { id: 20, name: "Empty", anim: 0, scale: 1 },
];

symbolAnimator.coinSymbolIds = [
  100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
  123, 124, 125, 126, 127, 128, 129,
];

symbolAnimator.initialise = function () {
  symbolAnimator.gameReels = gameData.reels;
  symbolAnimator.slotContainer = resourceManager.get("slotContainer:reelContainer");
  symbolAnimator.backingContainer = resourceManager.get("slotContainer:reelContainer:backingContainer");

  symbolAnimator.createPoolAnim("Rod", 0, [
    "High_Win_Rod_3x_anim",
    "High_Win_Rod_4x_anim",
    "High_Win_Rod_5x_anim",
    "High_Win_Rod_6x_anim",
    "High_Win_Rod_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Float", 0, [
    "Float_3x_anim",
    "Float_4x_anim",
    "Float_5x_anim",
    "Float_6x_anim",
    "Float_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Fisherman", 0, [
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
  ]);
  symbolAnimator.collectMultipleAnimName = "Fisherman_Regular";
  symbolAnimator.createPoolAnim("Trawler", 0, [
    "High_Win_Trawler_3x_anim",
    "High_Win_Trawler_4x_anim",
    "High_Win_Trawler_5x_anim",
    "High_Win_Trawler_6x_anim",
    "High_Win_Trawler_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Logo", 0, [
    "Logo_Symbol_3x_anim",
    "Logo_Symbol_4x_anim",
    "Logo_Symbol_5x_anim",
    "Logo_Symbol_6x_anim",
    "Logo_Symbol_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Tackle", 0, [
    "High_Win_Tackle_3x_anim",
    "High_Win_Tackle_4x_anim",
    "High_Win_Tackle_5x_anim",
    "High_Win_Tackle_6x_anim",
    "High_Win_Tackle_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Lure", 0, [
    "Lure_symbol_3x",
    "Lure_symbol_4x",
    "Lure_symbol_5x",
    "Lure_symbol_6x",
    "Lure_symbol_7x",
  ]);
  symbolAnimator.createPoolAnim("Wild", 0, [
    "Wild_3x_anim",
    "Wild_4x_anim",
    "Wild_5x_anim",
    "Wild_6x_anim",
    "Wild_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Ten", 0, [
    "Royal_10_3x_anim",
    "Royal_10_4x_anim",
    "Royal_10_5x_anim",
    "Royal_10_6x_anim",
    "Royal_10_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Ace", 0, [
    "Royal_A_3x_anim",
    "Royal_A_4x_anim",
    "Royal_A_5x_anim",
    "Royal_A_6x_anim",
    "Royal_A_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Jack", 0, [
    "Royal_J_3x_anim",
    "Royal_J_4x_anim",
    "Royal_J_5x_anim",
    "Royal_J_6x_anim",
    "Royal_J_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("King", 0, [
    "Royal_K_3x_anim",
    "Royal_K_4x_anim",
    "Royal_K_5x_anim",
    "Royal_K_6x_anim",
    "Royal_K_7x_anim",
  ]);
  symbolAnimator.createPoolAnim("Queen", 0, [
    "Royal_Q_3x_anim",
    "Royal_Q_4x_anim",
    "Royal_Q_5x_anim",
    "Royal_Q_6x_anim",
    "Royal_Q_7x_anim",
  ]);

  symbolAnimator.createPoolAnim("Respin", 0, ["Respin_Plus_1", "Respin_Plus_2", "Respin_Plus_3"]); // All 1 size but has different anims per respin amount

  symbolAnimator.ready = true;
};

symbolAnimator.createPoolAnim = function (name, index, animNames = undefined) {
  let spineAnim = undefined;
  let backings = [];
  let symbolId;
  for (let index = 0; index < symbolAnimator.symbolIDMap.length; index++) {
    if (symbolAnimator.symbolIDMap[index].name === name) {
      symbolId = symbolAnimator.symbolIDMap[index].id;
      break;
    }
  }

  let animNamesCheck = animNames;

  let found = false;

  //Search for pool name
  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    //If pool name exists add a new anim there
    if (poolType.poolName === name) {
      found = true;

      animNamesCheck = poolType.anims;

      spineAnim = resourceManager.createObject("spine", "Scale" + name + index, symbolAnimator.slotContainer, {
        name: name,
        defaultAnimation: animNamesCheck[0],
        scaleX: 1,
        scaleY: 1,
      });

      //create backings

      for (let i = 0; i < poolType.backingPool.fileNames.length; i++) {
        const backingFileName = poolType.backingPool.fileNames[i];

        const backing = resourceManager.createObject(
          "sprite",
          name + index + "Backing" + i,
          symbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
      }

      poolType.pool.push(spineAnim);
      poolType.number++;
      poolType.backingPool.pool.push([backings]);

      break;
    }
  }

  if (!found) {
    //Otherwise create a new anim pool with this name
    spineAnim = resourceManager.createObject("spine", "Scale" + name + index, symbolAnimator.slotContainer, {
      name: name,
      defaultAnimation: animNamesCheck[0],
      scaleX: 1,
      scaleY: 1,
    });

    //create backings
    const fileNames = [];

    for (let i = 0; i < animNamesCheck.length; i++) {
      const symbolIdOffset = i * 20;
      const backingFileName = symbolAnimator.getSymbolBackingFileName(symbolId + symbolIdOffset);

      if (backingFileName) {
        const backing = resourceManager.createObject(
          "sprite",
          name + index + "Backing" + i,
          symbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
        fileNames.push(backingFileName);
      }
    }

    symbolAnimator.animationPool.push({
      poolName: name,
      number: 0,
      pool: [spineAnim],
      anims: animNamesCheck,
      backingPool: {
        pool: [backings],
        fileNames: fileNames,
      },
    });
  }

  spineAnim.visible = false;

  return { spine: spineAnim, backings: backings };
};

symbolAnimator.findSpineAndBacking = function (symbolId) {
  let spine = undefined;
  let location = 0;
  symbolId = symbolId % 20;
  let spineAnimName = symbolAnimator.symbolIDMap[symbolId].name;

  if (spineAnimName === "Empty") {
    return undefined;
  }

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        spine = poolType.pool[0];
        backings = poolType.backingPool.pool[0];

        poolType.pool.splice(0, 1);
        poolType.backingPool.pool.splice(0, 1);
        return { spine: spine, backings: backings };
      }
    }
  }

  spineAndbackings = symbolAnimator.createPoolAnim(spineAnimName, number + 1);
  symbolAnimator.animationPool[location].pool.pop();
  symbolAnimator.animationPool[location].backingPool.pool.pop();

  return spineAndbackings;
};

symbolAnimator.animate = function (symbols, callback, callBackDelay) {
  symbolAnimator.finishedCallback = callback;
  symbolAnimator.callBackDelay = callBackDelay;

  const anims = [];
  for (let i = 0; i < symbols.length; i++) {
    let symbol = symbols[i];
    let symId = symbol.symbolId;

    if (!symbolAnimator.coinSymbolIds.includes(symId)) {
      anims.push(symbolAnimator.animateSymbol(symbol));
    }
  }
  return Promise.all(anims);
};

symbolAnimator.animateSymbol = function (symbol) {
  const id = symbol.symbolId % 20;
  let sizeOffset = Math.floor(symbol.symbolId / 20);
  const reel = symbol.cell.reel;
  const row = symbol.cell.row;

  let symbolMapIndex = undefined;

  for (let index = 0; index < symbolAnimator.symbolIDMap.length; index++) {
    if (symbolAnimator.symbolIDMap[index].id === id) {
      symbolMapIndex = index;
      break;
    }
  }

  let spineAndBacking = symbolAnimator.findSpineAndBacking(symbolMapIndex);

  if (spineAndBacking === undefined) {
    return;
  }

  let animNames = symbolAnimator.findAnimNames(symbolMapIndex);

  switch (id) {
    // respin +1
    case 15:
      animNum = 0;
      break;
    // respin +2
    case 16:
      animNum = 1;
      break;
    // respin +3
    case 17:
      animNum = 2;
      break;
    default:
      animNum =
        symbolAnimator.symbolIDMap[symbolMapIndex].anim === 0 && sizeOffset > 0
          ? 1 * sizeOffset
          : symbolAnimator.symbolIDMap[symbolMapIndex].anim * sizeOffset;
      break;
  }

  let symbolToHide = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  symbolToHide.visible = false;
  const spine = spineAndBacking.spine;
  const backing = spineAndBacking.backings[sizeOffset];

  if (backing) backing.visible = true;

  let animationObject = {
    anim: spine,
    reel: reel,
    row: row,
    backing: backing,
    symbolToHide: symbolToHide,
  };

  symbolAnimator.currentAnimations.push(animationObject);

  symbolAnimator.positionAnim(animationObject);

  spine.visible = true;

  let animName;
  // if colleting multiple then play a different spine anim
  const numCoins = gameController.inFreeSpins
    ? gameController.coinAwardsBeforeGoldenSpins.coins.length
    : gameController.coinAwards.coins.length;
  if (id === 14 && numCoins > 1) {
    //check how many coins
    animName = symbolAnimator.collectMultipleAnimName;
  } else {
    animName = animNames[animNum];
  }

  spine.anim = animName;

  return new Promise((res) => {
    spine.play(animName, false, 0, () => {
      symbolAnimator.animationFinished(animationObject);
      symbolAnimator.returnToPool(symbolAnimator.symbolIDMap[symbolMapIndex].name, spine, spineAndBacking.backings);
      symbolToHide.visible = true;
      res();
    });
  });
};

symbolAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.visible = false;
    if (animationObject.backing) animationObject.backing.visible = false;
    animationObject.symbolToHide.visible = true;
    symbolAnimator.currentAnimations.splice(symbolAnimator.currentAnimations.indexOf(animationObject), 1);
  }

  if (symbolAnimator.currentAnimations.length === 0) {
    if (symbolAnimator.finishedCallback) {
      if (symbolAnimator.callBackDelay !== undefined) {
        symbolAnimator.completeCallback = symbolAnimator.finishedCallback;
        timerManager.addTimeout(symbolAnimator.callBackDelay, function () {
          if (symbolAnimator.completeCallback) {
            symbolAnimator.completeCallback();
          }
        });
      } else {
        symbolAnimator.finishedCallback();
      }
    }
  }
};

symbolAnimator.findAnimNames = function (symbolId) {
  let spineAnimName = symbolAnimator.symbolIDMap[symbolId].name;

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      animNames = poolType.anims;
      return animNames;
    }
  }

  return undefined;
};

symbolAnimator.returnToPool = function (name, spine, backings) {
  if (backings) {
    for (let index = 0; index < backings.length; index++) {
      const backing = backings[index];
      backing.visible = false;
    }
  }

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(spine);
      backings && poolType.backingPool.pool.push(backings);
    }
  }
};

symbolAnimator.positionAnim = function (animationObject) {
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const reelObject = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const reelScale = reelObject.scale.x;

  symbol = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);

  const symbolPosForAnim = helper.getLocalFromGlobalPosition(symbol, anim, false);

  const xOffset = symbol.width / 2;
  const yOffset = symbol.height / 2;
  anim.position.set(symbolPosForAnim.x + xOffset, symbolPosForAnim.y + yOffset);
  anim.scale.set(reelScale);
  if (animationObject.backing) {
    const symbolPosForBacking = helper.getLocalFromGlobalPosition(symbol, animationObject.backing);
    animationObject.backing.position.set(symbolPosForBacking.x, symbolPosForBacking.y);
    animationObject.backing.scale.set(reelScale / 2);
  }
};

symbolAnimator.getSymbolBackingFileName = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  let fileName;

  if (symbolId >= 100 || id === 12 || id === 14 || id === 18 || id === 19) {
    fileName = undefined;
  } else {
    switch (sizeOffset) {
      case 0:
        fileName = "Symbols/symbolstatics/x3/BACK_BORDER_x3.png";
        break;
      case 1:
        fileName = "Symbols/symbolstatics/x4/BACK_BORDER_x4.png";
        break;
      case 2:
        fileName = "Symbols/symbolstatics/x5/BACK_BORDER_x5.png";
        break;
      case 3:
        fileName = "Symbols/symbolstatics/x6/BACK_BORDER_x6.png";
        break;
      case 4:
        fileName = "Symbols/symbolstatics/x7/BACK_BORDER_x7.png";
        break;
    }
  }

  return fileName;
};

symbolAnimator.skip = function () {
  symbolAnimator.currentAnimations.forEach((animation) => {
    symbolAnimator.returnToPool(animation.anim.name, animation.anim, animation.backing);
    animation.anim.visible = false;
    if (animation.backing) {
      animation.backing.visible = false;
    }
    animation.symbolToHide.visible = true;
  });

  symbolAnimator.currentAnimations = [];
  symbolAnimator.finishedCallback = undefined;
  symbolAnimator.completeCallback = undefined;
};

symbolAnimator.orientationChange = function () {
  if (symbolAnimator.ready) {
    timerManager.addTimer(5, () => {
      symbolAnimator.currentAnimations.forEach((animationObject) => {
        symbolAnimator.positionAnim(animationObject);
      });
      //gameData.winningsText.resetPosition();
    });
  }
};

Reflex.registerEventHandler("layoutChange", symbolAnimator.orientationChange);
Reflex.registerEventHandler("orientationChange", symbolAnimator.orientationChange);
